import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  getCategories,
  removeArticle
} from "../../actions/yellowpage";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  Button,
  UncontrolledAlert
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";

import DropdownSelection from "../../components/Commons/DropdownSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/yellowpage/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";
import { YELLOW_CATEGORIES } from "../../utils/constant";

class FreelancerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      activeCategoryType: null,
      activeCategoryType2: null,
      articles: [],
      subCategories: []
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.filterCat2 = this.filterCat2.bind(this);
    this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.filterSubCategories = this.filterSubCategories.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    // const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      // activeCategoryType: activeCategoryType
    });
    this.getCategories(category_id);
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
    if (newProps.yellowpage.categories !== this.props.yellowpage.categories) {
      let category = newProps.yellowpage.categories;
      if (category) {
        if (category.parent_id === 10) {
          this.filterSubCategories(category.id);

          this.setState({
            activeCategoryType: category.display_name,
            activeCategoryType2: null,
          })

        } else {
          this.filterSubCategories(category.parent_id);
          let activeCategoryType = this.getCurrentCategory(category.parent_id);
          this.setState({
            activeCategoryType: activeCategoryType,
            activeCategoryType2: category.display_name,
          })
        }
      } else {
        this.setState({
          subCategories: [],
          activeCategoryType: null,
          activeCategoryType2: null,
        })
      }
    }
  }

  filterSubCategories(id) {
    var matchRoles = YELLOW_CATEGORIES.filter(value => {
      return value.id === id;
    });
    var subCategories = [];
    if (matchRoles.length) {
      subCategories = matchRoles[0].sub_categories;
    }
    this.setState({
      subCategories
    })
  }

  getCurrentCategory(category_id) {
    var matchRoles = YELLOW_CATEGORIES.filter(value => {
      return value.id === category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCurrentCategory2(category_id) {
    var matchRoles = this.state.subCategories.filter(value => {
      return value.id === category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCategories(category_id) {
    this.props.getCategories({ category_id });
  }

  hideAlert() {
    this.setState({
      alert: ""
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: ""
    });
    this.props.removeArticle(row.id);
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      )
    });
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.filterSubCategories(category_id);
    this.setState({
      activeCategoryType: activeCategoryType,
      activeCategoryType2: null,
    });

    let urlParams = qs.parse(this.props.history.location.search);
    this.getCategories(category_id);
    let searchParams = {
      ...urlParams,
      category_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterCat2(category_id) {
    if (!category_id) {
      let currentCategory = this.props.yellowpage.categories;
      if (currentCategory.parent_id !== 10) {
        category_id = currentCategory.parent_id
      } else {
        category_id = currentCategory.id
      }
    }
    const activeCategoryType = this.getCurrentCategory2(category_id);
    this.setState({
      activeCategoryType2: activeCategoryType
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id
    };
    this.getCategories(category_id);
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterAuthor(author_id) {
    // const activeCategoryType = this.getCurrentCategory(author_id);
    // this.setState({
    //   activeCategoryType: activeCategoryType
    // });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      author_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      categories,
      errorMsg,
      successBackMsg
    } = this.props.yellowpage;
    var activeCategoryType = this.state.activeCategoryType;
    var activeCategoryType2 = this.state.activeCategoryType2;
    const heads = ["標題", "分類", "聯繫人", "浏览量", "操作"];
    const dataAttributes = [
      "status",
      "title",
      "category",
      "author",
      "created_at"
    ];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex  justify-content-between">
              <div className="d-flex align-items-center row">
                {/* <h4 className="mb-0 ml-4" style={{ lineHeight: '1' }}>篩選：</h4> */}
                <DropdownSelection
                  Types={YELLOW_CATEGORIES}
                  activeType={activeCategoryType}
                  filterType={this.filterCat}
                  disabled={this.props.yellowpage.getCategoriesRequest}
                />
                {activeCategoryType ?
                  <DropdownSelection
                    Types={this.state.subCategories}
                    activeType={activeCategoryType2}
                    filterType={this.filterCat2}
                    disabled={this.props.yellowpage.getCategoriesRequest}
                  /> : ''}
              </div>
              <div className="d-flex align-items-center">
                <SearchBar
                  search_string={this.state.title}
                  onSearchInputChange={this.onSearchInputChange}
                />
                <Button
                  className="btn btn-default"
                  tag={Link}
                  to={"/dash/admin/yellow-pages/new"}
                >
                  添加黃頁
                </Button>
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={page => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    yellowpage: state.yellowpage,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticles: params => dispatch(getArticles(params)),
    getCategories: params => dispatch(getCategories(params)),
    removeArticle: params => dispatch(removeArticle(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreelancerPage);
